import Fallback from "app/components/Fallback";
import React from "react";

const SchoolUserDetail = React.lazy(() => import("./pages/SchoolUserDetail"));

export const SchoolUserDetailPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <SchoolUserDetail {...props} />
  </React.Suspense>
);
